import { schemes, zSchema } from "@zeal/common";

export const createGoogleWalletProvisionRequestSchema = zSchema.object({
  paycard_id: schemes.uuid(),
  device_id: zSchema.string(),
  wallet_account_id: zSchema.string(),
  companyID: schemes.companyID(),
  app_version: zSchema.string(),
});
export type TCreateGoogleWalletProvisionRequest = zSchema.infer<
  typeof createGoogleWalletProvisionRequestSchema
>;

export const createGoogleWalletProvisionResponseSchema = zSchema.object({
  card_id: zSchema.string(),
  device_type: zSchema.string(),
  provisioning_app_version: zSchema.string(),
  push_tokenize_request_data: zSchema.object({
    display_name: zSchema.string(),
    last_digits: zSchema.string(),
    network: zSchema.string(),
    opaque_payment_card: zSchema.string(),
    token_service_provider: zSchema.string(),
    user_address: zSchema.object({
      address1: zSchema.string(),
      address2: zSchema.string(),
      city: zSchema.string(),
      country: zSchema.string(),
      name: zSchema.string(),
      phone: zSchema.string(),
      postal_code: zSchema.string(),
      state: zSchema.string(),
    }),
  }),
});
export type TCreateGoogleWalletProvisionResponse = zSchema.infer<
  typeof createGoogleWalletProvisionResponseSchema
>;
